import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function PageHeader({ title, breadcrumb = [] }) {
  const { t } = useLang();
  return (
    <section className="relative bg-[#4a2e1a] text-white overflow-hidden">
      <div className="absolute -top-20 -right-10 w-[420px] h-[420px] rounded-full bg-[#f5b300]/12 blur-3xl" />
      <div className="absolute -bottom-24 -left-10 w-[360px] h-[360px] rounded-full bg-[#6b3f24]/40 blur-3xl" />
      <div className="absolute inset-0 dotted-pattern opacity-20 pointer-events-none" />

      <div className="relative max-w-[1280px] mx-auto px-6 py-20 md:py-28 text-center">
        <p className="section-eyebrow text-[#f5b300] mb-4">WYSE Tribe</p>
        <h1 className="text-[40px] md:text-[58px] font-extrabold leading-tight text-white">{title}</h1>
        <div className="mt-5 flex items-center justify-center gap-2 text-[13.5px] text-white/75">
          <Link to="/" className="hover:text-[#f5b300] flex items-center gap-1.5">
            <Home className="w-3.5 h-3.5" /> {t('nav.home')}
          </Link>
          {breadcrumb.map((b) => (
            <React.Fragment key={b}>
              <ChevronRight className="w-3.5 h-3.5" />
              <span className="text-[#f5b300]">{b}</span>
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}
